import * as React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import type { SidebarFooterProps } from '@toolpad/core/DashboardLayout';

// Toolpad's DashboardLayout sidebarFooter slot — __APP_VERSION__ is injected by vite.config.ts
// from this app's own package.json "version" (kept in sync across all four apps by
// bump-version.ps1, which is the only place that ever changes it).
const AppVersionFooter: React.FC<SidebarFooterProps> = ({ mini }) => {
    const { t } = useTranslation();

    return (
        <Box sx={{ px: 2, py: 1, textAlign: 'center' }}>
            <Typography variant="caption" color="text.secondary" noWrap>
                {mini ? `v${__APP_VERSION__}` : t('common.appVersion', { version: __APP_VERSION__ })}
            </Typography>
        </Box>
    );
};

export default AppVersionFooter;
